import { render, staticRenderFns } from "./CoachBookingItem.vue?vue&type=template&id=3ebdbfb0&scoped=true&"
import script from "./CoachBookingItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./CoachBookingItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CoachBookingItem.vue?vue&type=style&index=0&id=3ebdbfb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebdbfb0",
  null
  
)

export default component.exports